// D107: no price may exist without a registered vendor. On a quotation, a line with no REAL
// vendor cannot get a hand-typed cost - its cost cell opens the Master Catalogue "Add item"
// popup instead (vendor required), and the line is priced from that save.
//
// "Real" = a vendor name that is not blank and not a placeholder ("Master Catalogue", "Client",
// "Unknown vendor" ...). `isPseudoVendorName` (utils/poSendStatus) is the one owner of the
// placeholder list; the server refuses the same lines with QUOTATION_LINE_COST_NEEDS_VENDOR.
import { isPseudoVendorName } from '../../utils/poSendStatus';

export const LINE_COST_NEEDS_VENDOR_CODE = 'QUOTATION_LINE_COST_NEEDS_VENDOR';

/** The ONE sentence for the refusal, whether it comes from the server's code or a client check. */
export const LINE_COST_NEEDS_VENDOR_MESSAGE =
  'This line has no vendor. Add the item to the Master Catalogue with its vendor to price it.';

/** Takes a line, or `{ selectedVendor: name }` for a bare vendor name. */
export const lineHasRealVendor = (line: { selectedVendor?: string | null } | null | undefined): boolean => {
  const name = String(line?.selectedVendor ?? '').trim();
  return name !== '' && !isPseudoVendorName(name);
};

/** Thrown when a price would be written to a line that has no real vendor. */
export class LineCostNeedsVendorError extends Error {
  readonly code = LINE_COST_NEEDS_VENDOR_CODE;
  constructor() {
    super(LINE_COST_NEEDS_VENDOR_MESSAGE);
    this.name = 'LineCostNeedsVendorError';
  }
}

/** Is this the no-vendor refusal - from the server (422) or from a client check? Nothing else. */
export const isLineCostNeedsVendorError = (e: unknown): boolean =>
  (e as { code?: unknown } | null)?.code === LINE_COST_NEEDS_VENDOR_CODE;
